document.addEventListener('DOMContentLoaded', () => {
    // slick default setting
    let defaulsettings = {
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            nextEl: '.swiper-prev',
            prevEl: '.swiper-next'
        },
        autoplay: {
            delay: 5000,
            disableOnInteraction: false
        }
    };

    // start slider default
    let allSwipper =[];

    document.querySelectorAll('.swiper-slider').forEach((element,i) => {

        let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaulsettings;
        element.setAttribute(`data-swiper-${i}`,"");
        let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);
        allSwipper[i] = swiper;

    });

    let quadAmenities = new Swiper('.slider-amenities__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.amenities-prev',
            nextEl: '.amenities-next'
        }
    });

    let slidercontact = new Swiper('.contact__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        autoHeight: true,
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.contact-prev',
            nextEl: '.contact-next'
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let quadReviews = new Swiper('.reviews__slider',{
        loop: true,
        speed: 700,
        effect: 'fade',
        fadeEffect: {
            crossFade: true
        },
        navigation: {
            prevEl: '.reviews-prev',
            nextEl: '.reviews-next'
        },
        autoplay: {
            delay: 7000,
            disableOnInteraction: false
        }
    });

    let sliderRooms = document.querySelectorAll('.venues-quad__slider');

    sliderRooms.forEach((sliderRoom)=>{
        let dataRoom = sliderRoom.dataset.entry;
        sliderRoom.setAttribute(`data-room-swiper-${dataRoom}`, "");
        let swiperRoom = new Swiper(`[data-room-swiper-${dataRoom}]`,{
            loop: true,
            speed: 700,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
            pagination: {
                el: `.rooms-pagination-${dataRoom}`,
                clickable: true,
            },
            navigation: {
                prevEl: `.rooms-${dataRoom}-prev`,
                nextEl: `.rooms-${dataRoom}-next`
            }
        });
    })

});